module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.lightblue-9c2f6cba7b067f6f7ffcb91cdb62e86b.svg";